export var getDocument = function getDocument() {
  if (typeof document !== 'undefined') {
    return document;
  }
  return null;
};